import React, { useEffect, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useForm, Controller } from "react-hook-form";
import { Box, Button, Modal, TextField } from '@mui/material';

import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

import api from '@/services/api';

import Spinner from '@/views/components/Spinner/Spinner';

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 400,
	background: '#FFFFFF 0% 0% no-repeat padding-box',
	boxShadow: '0px 3px 6px #00000029',
	borderRadius: '6px',
	padding: '40px',
};

const defaultValues = {
	inputPhrase: '',
	outputPhrase: '',
	basicInputPhrase: '',
	basicOutputPhrase: '',
	comments: '',
};
const validationSchema = Yup.object({
	inputPhrase: Yup.string().required("To pole jest obowiązkowe"),
	outputPhrase: Yup.string().required("To pole jest obowiązkowe"),
});

const ModalAddNewItem = ({
	reloadDictionary,
	modalVisible,
	setModalVisible,
	editValues = null,
	setEditValues = null,
}) => {
	//// IF editValues isn't null - switch do edit Mode
	const { dict } = useSelector((state) => state.app);
	const [ loading, setLoading ] = useState(false);
	const [ editMode, setEditMode ] = useState(false);
	const [ editItemId, setEditItemId ] = useState(null);

	const handleClose = useCallback(() => {
		if (setEditValues) setEditValues(null);
		setModalVisible(false);
	}, []);

	const { handleSubmit, control, formState: { errors }, watch } = useForm({
		resolver: yupResolver(validationSchema),
		defaultValues: editValues || defaultValues,
	});

	const watchInputPhrase = watch('inputPhrase');
	const watchOutputPhrase = watch('outputPhrase');

	useEffect(() => {
		if (!editValues) return setEditMode(false);
		setEditItemId(editValues.id);
		setEditMode(true);
	}, [ editValues ]);

	const onFormSent = () => {
		reloadDictionary();
		setLoading(false);
		handleClose();
	};
	const onFormErrors = (response) => {
		// eslint-disable-next-line no-console
		console.log(response);
		// if (response.status === 400) {
		// 	if (response.data.errors.length > 0) {
		// 		setErrors(response.data.errors.map( error =>
		// 			error.code.length > 0 ? error.code.split(".").join('') : null,
		// 		).filter( el => el ));
		// 	}
		// }
	};

	const onSubmit = data => {
		setLoading(true);
		if (editMode) return (
			api.put(`/dict-entries/${editItemId}`, data)
				.then(() => {
					onFormSent();
				}).catch(({ response }) => {
					setLoading(false);
					onFormErrors(response);
				})
		);
		api.post(`/dict-entries`, data)
			.then(() => {
				onFormSent();
			}).catch(({ response }) => {
				setLoading(false);
				onFormErrors(response);
			});
	};

	return (
		<Modal
			open={ modalVisible }
			onClose={ handleClose }
			aria-labelledby='modal-modal-title'
			aria-describedby='modal-modal-description'
		>
			<Box sx={ style }>
				{
					loading && (
						<Spinner addClass='dictionary__spinner' />
					)
				}
				<form
					onSubmit={ handleSubmit(onSubmit) }
					// style={ style }
				>
					<h1>{editMode ?
						dict.dictionary.modal.editForm :
						dict.dictionary.modal.addToDict}
					</h1>
					<hr />
					<p className="modal-children__required modal-children__required--space">{dict.required}</p>

					{Object.keys(defaultValues).map((item, index) => (
						<section
							key={ item }
							className='form__section'
						>
							<label className='form__label'>{dict.dictionary[item]}{(index === 0 || index === 1) && ' *'}</label>
							{(item === 'comments') ? (
							// form comments - multiline textField
								<Controller
									render={ ({ field }) => <TextField
										size='small'
										fullWidth
										multiline
										minRows={ 3 }
										maxRows={ 6 }
										helperText={ errors[item] && errors[item].message }
										error={ !!errors[item] }
										inputProps={ { maxLength: 4096 } }
										{ ...field } 
									/> }
									name={ item }
									control={ control }
									errors={ errors[item] }
								/>
							) : (
								<Controller
									render={ ({ field }) => <TextField 
										size='small'
										fullWidth
										autoFocus={ index === 0 }
										helperText={ errors[item] && errors[item].message }
										error={ !!errors[item] }
										inputProps={ { maxLength: 4096 } }
										{ ...field } 
									/> }
									name={ item }
									control={ control }
									errors={ errors[item] }
								/>
							)}

						</section>
					))}
					<hr className="modal-children__line"/>
					<section className='form__buttons'>
						<Button
							color='primary'
							variant='contained'
							className='button__transparent'
							sx={ { textTransform: 'none' } }
							onClick={ handleClose }
						>
							{dict.cancel}
						</Button>
						<Button
							color='primary'
							type='submit'
							variant='contained'
							fullWidth
							className={ `button__blue${(watchInputPhrase.replace(/[ ]+$/g, '').length > 0 && watchOutputPhrase.replace(/[ ]+$/g, '').length > 0) ? '' : ' disabled'}` }
							sx={ { textTransform: 'none' } }
						>
							{editMode ? dict.dictionary.modal.actualize : dict.dictionary.addToDict}
						</Button>
					</section>
				</form>
			</Box>
		</Modal>
	);
};

export default React.memo(ModalAddNewItem);